import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppointmentInventory } from 'src/app/core/models/appointment-inventory.model';
import { Appointment } from 'src/app/core/models/appointment.model';
import { AppointmentService } from 'src/app/core/services/appointment/appointment.service';

@Component({
	selector: 'app-inventory-remove-tab',
	templateUrl: './inventory-remove-tab.component.html',
	styleUrls: ['./inventory-remove-tab.component.scss'],
})
export class InventoryRemoveTabComponent {

	activeAppointmentSub: any;
	toBeRemovedItems: AppointmentInventory[];
	removedItems: AppointmentInventory[];
	expandedToBeRemovedItems = [] as number[];
	expandedRemovedItems = [] as number[];

	constructor(
		private activatedRoute: ActivatedRoute,
		private appointmentService: AppointmentService,
	) { }

	async ionViewWillEnter() {
		const id = this.activatedRoute.snapshot.parent.parent.params?.id;
		const appointment = await this.appointmentService.getLocalAppointment(id);
		this.setItems(appointment);
		this.updateItemsAfterSync();
	}

	ionViewWillLeave() {
		this.activeAppointmentSub.unsubscribe();
	}

	setItems(appointment: Appointment) {
		this.toBeRemovedItems = appointment.inventory
			.filter(i => i.statusId == 5)
			.sort((a, b) => a.id - b.id);

		this.removedItems = appointment.inventory
			.filter(i => i.statusId != 1 && i.statusId != 5 && i.originalStatusId == 1)
			.sort((a, b) => a.id - b.id);
	}

	updateItemsAfterSync() {
		this.activeAppointmentSub = this.appointmentService.activeAppointment$
			.subscribe(newAppointment => {
				if (newAppointment) {
					this.setItems(newAppointment);
				}
			});
	}

	onClickToggleSection(sectionIndex: number, list: number[]) {
		const foundIndex = list.findIndex(index => index === sectionIndex);
		if (foundIndex === -1) {
			list.push(sectionIndex);
			return;
		}

		list.splice(foundIndex, 1);
	}

	isVisible(sectionIndex: number, list: number[]) {
		return (list.findIndex(index => index === sectionIndex) > -1);
	}

}
